'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  color: _propTypes2.default.string,
  font: _propTypes2.default.string,
  fontFamily: _propTypes2.default.string,
  fontSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  fontStyle: _propTypes2.default.string,
  fontVariant: _propTypes2.default.string,
  fontWeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  letterSpacing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  lineHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  textAlign: _propTypes2.default.string,
  textDecoration: _propTypes2.default.string,
  textOverflow: _propTypes2.default.string,
  textShadow: _propTypes2.default.string,
  textTransform: _propTypes2.default.string,
  whiteSpace: _propTypes2.default.string,
  wordBreak: _propTypes2.default.string,
  wordWrap: _propTypes2.default.string
};

var propAliases = exports.propAliases = {};

var propValidators = exports.propValidators = {};

var _textAlign = {
  className: 'txt-algn',
  safeValue: true,
  cssName: 'text-align',
  jsName: 'textAlign'
};
var _textDecoration = {
  className: 'txt-deco',
  cssName: 'text-decoration',
  jsName: 'textDecoration'
};
var _textTransform = {
  className: 'txt-trns',
  cssName: 'text-transform',
  jsName: 'textTransform',
  safeValue: true
};
var _textShadow = {
  className: 'txt-shdw',
  cssName: 'text-shadow',
  jsName: 'textShadow',
  complexValue: true
};
var _textOverflow = {
  className: 'txt-ovrf',
  cssName: 'text-overflow',
  jsName: 'textOverflow',
  safeValue: true
};
var _color = {
  className: 'color',
  cssName: 'color',
  jsName: 'color'
};
var _font = {
  className: 'fnt',
  cssName: 'font',
  jsName: 'font',
  complexValue: true
};
var _fontFamily = {
  className: 'fnt-fam',
  cssName: 'font-family',
  jsName: 'fontFamily',
  complexValue: true
};
var _fontSize = {
  className: 'fnt-sze',
  cssName: 'font-size',
  jsName: 'fontSize'
};
var _fontStyle = {
  className: 'fnt-stl',
  cssName: 'font-style',
  jsName: 'fontStyle',
  safeValue: true
};
var _fontVariant = {
  className: 'f-vari',
  cssName: 'font-variant',
  jsName: 'fontVariant'
};
var _fontWeight = {
  className: 'f-wght',
  cssName: 'font-weight',
  jsName: 'fontWeight',
  safeValue: true,
  defaultUnit: ''
};
var _lineHeight = {
  className: 'ln-ht',
  cssName: 'line-height',
  jsName: 'lineHeight',
  defaultUnit: ''
};
var _wordBreak = {
  className: 'wrd-brk',
  cssName: 'word-break',
  jsName: 'wordBreak',
  safeValue: true
};
var _wordWrap = {
  className: 'wrd-wrp',
  cssName: 'word-wrap',
  jsName: 'wordWrap',
  safeValue: true
};
var _whiteSpace = {
  className: 'wht-spc',
  cssName: 'white-space',
  jsName: 'whiteSpace',
  safeValue: true
};
var _letterSpacing = {
  className: 'ltr-spc',
  cssName: 'letter-spacing',
  jsName: 'letterSpacing'
};

var propEnhancers = exports.propEnhancers = {
  color: function color(value) {
    return (0, _getCss2.default)(_color, value);
  },
  font: function font(value) {
    return (0, _getCss2.default)(_font, value);
  },
  fontFamily: function fontFamily(value) {
    return (0, _getCss2.default)(_fontFamily, value);
  },
  fontSize: function fontSize(value) {
    return (0, _getCss2.default)(_fontSize, value);
  },
  fontStyle: function fontStyle(value) {
    return (0, _getCss2.default)(_fontStyle, value);
  },
  fontVariant: function fontVariant(value) {
    return (0, _getCss2.default)(_fontVariant, value);
  },
  fontWeight: function fontWeight(value) {
    return (0, _getCss2.default)(_fontWeight, value);
  },
  letterSpacing: function letterSpacing(value) {
    return (0, _getCss2.default)(_letterSpacing, value);
  },
  lineHeight: function lineHeight(value) {
    return (0, _getCss2.default)(_lineHeight, value);
  },
  textAlign: function textAlign(value) {
    return (0, _getCss2.default)(_textAlign, value);
  },
  textDecoration: function textDecoration(value) {
    return (0, _getCss2.default)(_textDecoration, value);
  },
  textOverflow: function textOverflow(value) {
    return (0, _getCss2.default)(_textOverflow, value);
  },
  textShadow: function textShadow(value) {
    return (0, _getCss2.default)(_textShadow, value);
  },
  textTransform: function textTransform(value) {
    return (0, _getCss2.default)(_textTransform, value);
  },
  whiteSpace: function whiteSpace(value) {
    return (0, _getCss2.default)(_whiteSpace, value);
  },
  wordBreak: function wordBreak(value) {
    return (0, _getCss2.default)(_wordBreak, value);
  },
  wordWrap: function wordWrap(value) {
    return (0, _getCss2.default)(_wordWrap, value);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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